import React from 'react';
import { Grid, Typography } from '@mui/material';
import SparkCarousel from 'sharedComponents/UI/SparkCarousel';
import MemoryCard from '../MemoryCard';
import type { JoinedMemory, Memory } from 'types/Memory';
import type { FavouriteList } from 'types/FavouriteList';

type GroupedFavourites = {
  memory: JoinedMemory[];
  favourite: FavouriteList;
};
type FavouriteSectionProps = {
  favMemory: GroupedFavourites;
  isLoading?: boolean;
};

function FavouriteSection({
  favMemory,
  isLoading = false,
}: FavouriteSectionProps) {
  if (!favMemory.memory?.length && !isLoading) {
    return null;
  }
  return (
    <Grid container gap={2} direction='column' marginBottom={3}>
      <Grid item paddingLeft={2}>
        <Typography fontFamily='Mont-Semibold' variant='h6'>
          {favMemory.favourite.attributes.name}
        </Typography>
      </Grid>
      <Grid item container>
        <SparkCarousel isLoading={isLoading} onLastElementView={() => {}}>
          {favMemory.memory?.map((memory) => (
            <MemoryCard key={memory.id} joinedMemory={memory} />
          ))}
        </SparkCarousel>
      </Grid>
    </Grid>
  );
}

export default FavouriteSection;
